import { InjectionToken } from '@angular/core';
import { OAuth2AuthenticateOptions } from '@byteowls/capacitor-oauth2';

export const AUTHENTICATE_OPTIONS = new InjectionToken<OAuth2AuthenticateOptions>('AUTHENTICATE_OPTIONS');
